(function () {
    'use strict';
    jQuery(function() {
        // Retrieve all the landing cards
        let cards = Array.from(document.querySelectorAll('.qld__landing-card'));
    
        // If we have landing cards, loop through each of them and save the data-id value.
        if (cards.length > 0) {
            cards.forEach((card) => {
                let uniqueID = card.getAttribute('data-id');
    
                // Initialise the carousels individually using the unique ID, rather than using a blanket class.
                $(`.qld__landing-card--${uniqueID} .qld__landing-carousel`).slick({
                    appendArrows: `.qld__landing-card--${uniqueID} .qld__landing-carousel-nav`,
                      infinite: false,
                });
    
                // If the slide counter HTML exists, set it to update whenever the afterChange event fires.
                $(`.qld__landing-card--${uniqueID} .qld__landing-carousel`).on('afterChange', function(slick, currentSlide) {
                    let counter = card.querySelector('.qld__landing-carousel-counter');
    
                    if (counter instanceof HTMLElement) {
                        counter.innerText = `${currentSlide.currentSlide + 1} of ${currentSlide.slideCount}`;
                    }
                });
    
                // To help with performance, we will force a lazy load on hidden iframes before they come into view.
                $(`.qld__landing-card--${uniqueID} .qld__landing-carousel`).on('beforeChange', function(slick, currentSlide) {
                    let slider = currentSlide.$list[0];
                    let iframe = null;
    
                    // If the slide track exists, we want to identify the new current slide.
                    if (slider instanceof HTMLElement) {
                        iframe = slider.querySelectorAll('iframe')[currentSlide.currentSlide + 1];
    
                        // If we have an iframe, update the src tag and remove the data-src. This will prevent
                        // the iframe having to reload its contents.
                        if (iframe instanceof HTMLElement &&
                            iframe.getAttribute('data-src')
                        ) {
                            iframe.setAttribute('src', iframe.getAttribute('data-src'));
                            iframe.removeAttribute('data-src');
                        }
                    }
                });
            });
        }
    });
}());